import apiClient from "./axios"

// ============================
// 🔹 Quotation API Services
// ============================

// Get all quotations (paginated or filtered)
export const getQuotations = async (params = {}) => {
  const { data } = await apiClient.get("/quotations", { params })
  return data
}

// Get a specific quotation by ID
export const getQuotation = async id => {
  const { data } = await apiClient.get(`/quotations/${id}`)
  return data
}

// Create a new quotation
export const createQuotation = async quotationData => {
  const { data } = await apiClient.post("/quotations", quotationData)
  return data
}

// Update an existing quotation
export const editQuotation = async ({ id, ...quotationData }) => {
  const { data } = await apiClient.patch(`/quotations/${id}`, quotationData)
  return data
}

// Check existing money receipts for a quotation's customer+vehicle
export const getQuotationExistingReceipts = async id => {
  const { data } = await apiClient.get(`/quotations/${id}/existing-receipts`)
  return data
}

// Check existing similar quotations (same customer+vehicle)
export const getQuotationSimilar = async id => {
  const { data } = await apiClient.get(`/quotations/${id}/similar`)
  return data
}

// Generate supportive quotations (min 2) on different company pads
export const generateSupportiveQuotations = async ({ id, items }) => {
  const { data } = await apiClient.post(`/quotations/${id}/supportive`, {
    items,
  })
  return data
}

// Get a single supportive quotation
export const getSupportiveQuotation = async id => {
  const { data } = await apiClient.get(`/supportive-quotations/${id}`)
  return data
}

// Update an existing supportive quotation
export const updateSupportiveQuotation = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/supportive-quotations/${id}`, payload)
  return data
}

// Get a supportive quotation's loan/type information
export const getSupportiveLoan = async id => {
  const { data } = await apiClient.get(`/supportive-quotations/${id}/loan`)
  return data
}

// Save a supportive quotation's loan/type information
export const updateSupportiveLoan = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(
    `/supportive-quotations/${id}/loan`,
    payload
  )
  return data
}

// Soft-delete a supportive quotation
export const deleteSupportiveQuotation = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.delete(`/supportive-quotations/${resolvedId}`)
  return data
}

// Permanently delete a supportive quotation
export const forceDeleteSupportiveQuotation = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.delete(
    `/supportive-quotations/${resolvedId}/force-delete`
  )
  return data
}

// Restore a soft-deleted supportive quotation
export const restoreSupportiveQuotation = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.post(
    `/supportive-quotations/${resolvedId}/restore`
  )
  return data
}

// Duplicate a quotation (creates a fresh pending copy)
export const duplicateQuotation = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.post(`/quotations/${resolvedId}/duplicate`)
  return data
}

// Soft delete a quotation
export const deleteQuotation = async id => {
  const resolvedId = typeof id === "object" ? id?.id : id
  const { data } = await apiClient.delete(`/quotations/${resolvedId}`)
  return data
}

// Get all quotations without pagination
export const getAllQuotations = async (params = {}) => {
  const { data } = await apiClient.get("/quotations", {
    params: { ...params, all: true },
  })
  return data
}

// Search quotations by QID, customer, or vehicle
export const searchQuotations = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/quotations", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed quotations
export const getTrashedQuotations = async (params = {}) => {
  const { data } = await apiClient.get("/quotations/trashed", { params })
  return data
}

// Restore a trashed quotation
export const restoreQuotation = async id => {
  const { data } = await apiClient.post(`/quotations/${id}/restore`)
  return data
}

// Permanently delete a quotation
export const forceDeleteQuotation = async id => {
  const { data } = await apiClient.delete(`/quotations/${id}/force-delete`)
  return data
}
